/**
 * A1-93 (4) — which calculation a page load should open.
 *
 * Two candidates exist on a hard load: the `?calc_id=` in the URL and the
 * calc this TAB last had loaded (sessionStorage "vat.calcId"). The URL used
 * to win unconditionally, so an OLD `?calc_id=` left in browser history
 * (WorkflowLayout pushed a new entry after opening it) came back on Back +
 * reload and silently replaced the newer calc the operator was working on.
 *
 * Rule: the URL wins when the operator navigated to it explicitly (a link,
 * a typed address, an in-app "open this calculation"). On a RELOAD or a
 * BACK/FORWARD load, a URL calc that differs from the tab's loaded calc is
 * a leftover, and the loaded calc wins. WorkflowLayout now also replaces
 * (never pushes) the history entry once a URL calc is opened, so the
 * leftover cannot be created any more; this covers entries made before.
 */
const navigationType = () => {
  try {
    const nav = window.performance?.getEntriesByType?.("navigation")?.[0];
    return nav?.type || null;
  } catch {
    return null;
  }
};

export const resolveBootCalcIds = () => {
  if (typeof window === "undefined") return { urlCalcId: null, savedCalcId: null, ignoredUrlCalcId: null };
  const urlCalcId = new URLSearchParams(window.location.search).get("calc_id");
  const savedCalcId = sessionStorage.getItem("vat.calcId");
  const type = navigationType();
  const leftover = !!urlCalcId && !!savedCalcId && urlCalcId !== savedCalcId
    && (type === "reload" || type === "back_forward");
  return {
    urlCalcId: leftover ? null : urlCalcId,
    savedCalcId,
    ignoredUrlCalcId: leftover ? urlCalcId : null,
  };
};
